import { getRegionNameByCode } from './getRegionNameByCode';

import type { Locales } from '@monoimin/sb-types';

interface FormatPropertyLocationArgs {
  countryCode?: string;
  locale: Locales;
  cityName?: string;
}

export function formatPropertyLocation({
  cityName,
  locale,
  countryCode,
}: FormatPropertyLocationArgs): string {
  const regionNamesInLocale = getRegionNameByCode(locale);

  const countryName =
    countryCode && regionNamesInLocale.of(String(countryCode).substring(0, 2));

  if (countryName && cityName) {
    return `${countryName}, ${cityName}`;
  }

  return countryName || '';
}

export default formatPropertyLocation;
